import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n) ;
const i18n = new VueI18n({
    locale:"zh",  //默认设置中文
    messages:{
        zh : require("@/assets/lang/zh.json"), //中文@代表当前文件夹的根目录
        en : require("@/assets/lang/en.json") //英文
    }         
})
export default i18n;


// WEBPACK FOOTER //
// ./src/plugins/i18n.js